module.exports = {"title":"MTI Licensing issue","ok":"Ok","description":"There is an issue with your access code, please <a href=\"http://calendly.com/showtix4u\" target=\"_blank\">SCHEDULE A CALL</a> with ShowTix4U or use the Live Chat feature if during business hours."}


//////////////////
// WEBPACK FOOTER
// ./src/components/CreateEvent/MTIModalError/locales/en.json
// module id = 1685
// module chunks = 0